module.exports = __webpack_public_path__ + "media/images/patterns/circle-ocean-5228c5d56c22c65fb1e802f2069546b4.svg";